import { BankAccount } from '../../components/BankAccountManager/props';
import { StripeEnv } from '../../util/enums';
import { StripeError } from './errors';
import { vaultRequest } from './request';

const GET_STRIPE_CONNECT_ACCOUNT_BANK_ACCOUNT_LIST = `
query VaultStripeConnectAccountBankAccountListFetch(
  $stripeConnectAccountId: String!
  $stripeEnv: VaultStripeEnv
) {
  bankAccountList: vaultStripeConnectAccountBankAccountListFetch(
    stripeConnectAccountId: $stripeConnectAccountId
    stripeEnv: $stripeEnv
  ) {
    account_holder_name
    account_holder_type
    bank_name
    country
    currency
    default_for_currency
    fingerprint
    id
    last4
    routing_number
    status
  }
}

`;

const DELETE_STRIPE_CONNECT_BANK_ACCOUNT = `
mutation VaultStripeConnectAccountBankAccountDelete(
  $bankAccountId: String!
  $stripeEnv: VaultStripeEnv
  $stripeConnectAccountId: String!
  $orgId: ID
) {
  response: vaultStripeConnectAccountBankAccountDelete(
    bankAccountId: $bankAccountId
    stripeEnv: $stripeEnv
    stripeConnectAccountId: $stripeConnectAccountId
    orgId: $orgId
  ) {
    errors {
      message
      type
    }
    success
  }
}
`;

export const getStripeConnectAccountBankAccounts = async (
  stripeConnectAccountId: string,
  stripeEnv?: StripeEnv,
): Promise<BankAccount[]> => {
  const bankAccountsRes = await vaultRequest(
    GET_STRIPE_CONNECT_ACCOUNT_BANK_ACCOUNT_LIST,
    {
      stripeConnectAccountId,
      stripeEnv,
    },
  );

  const bankAccountsResJson = await bankAccountsRes.json();
  if (bankAccountsResJson.errors && bankAccountsResJson.errors.length > 0) {
    throw new StripeError(
      'Could not fetch the bank accounts list of Stripe Connect Account',
      bankAccountsResJson.errors[0],
    );
  }
  return bankAccountsResJson.data.bankAccountList;
};

export const deleteStripeConnectAccountBankAccount = async (
  stripeConnectAccountId: string,
  bankAccountId: string,
  stripeEnv?: StripeEnv,
  orgId?: string,
): Promise<boolean> => {
  const bankAccountDeletedRes = await vaultRequest(
    DELETE_STRIPE_CONNECT_BANK_ACCOUNT,
    {
      stripeConnectAccountId,
      bankAccountId,
      stripeEnv,
      orgId,
    },
  );
  const bankAccountDeletedResJson = await bankAccountDeletedRes.json();
  if (
    bankAccountDeletedResJson.errors &&
    bankAccountDeletedResJson.errors.length > 0
  ) {
    throw new StripeError(
      'Could not delete bank account of Stripe Connect Account',
      bankAccountDeletedResJson.errors[0],
    );
  }
  return bankAccountDeletedResJson.data.response.success;
};
